(function ($, Drupal, once) {
  Drupal.behaviors.Vanity = {
    attach: function (context, settings) {

      var modalbutton = $('.ui-front .btn-red', context).length;
      if (modalbutton) {
        var modalfooter = $('.ui-front .btn-red', context).outerHTML();
        $('#drupal-modal', context).dialog().wrapAll('<div id="drupal-wrapper" class="modal-wrapper"></div>');
        $('#drupal-wrapper').append('<div class="modal-footer">' + modalfooter + '</div>');
        $('#drupal-modal', context).find('.btn-red').css({'display':'none'});
      }

      var hero = $('.paragraph--type--headerbild', context).length;
      if (hero) {
        var headerfooter = $('.paragraph--type--headerbild', context).html().replace('container','container-fluid');
        $('header').addClass('hasBack');
        $('header').append('<div class="hero" style="">' + headerfooter + '</div>');
      }

      var kats = [];
      $('.jobkategorieheader', context).each(function() {
        var mclass = $(this).attr('class').split(/\s+/).pop();
        kats.push(mclass);
      });

      $('.views-field-field-ueberschrift a', context).each(function(){
        var target = $(this).attr('class');
        var hasjob = false;
        for (var i = 0; i < kats.length; i++) {
          if (kats[i].indexOf(target) !== -1) {
            hasjob = true;
          }
        }
        if (hasjob) {
          $(this).addClass('hasjob');
        }
      });

      var activeHash = [];
      $(once('vanity-links', '.views-field-field-ueberschrift a', context)).on('click touch', function(e){
        if(!$(this).hasClass('hasjob')) {
          e.preventDefault();
        }
        var hash = $(this).attr('class').split(' ');
        if ($.inArray(hash[0], activeHash) === -1) {
          activeHash.push(hash[0]);
        }

        $('.jobkategorieheader', context).css({'display': 'none'});
        $('.jobkategorieheader', context).prev('p').css({'display': 'none'});
        for (var i = 0; i < activeHash.length; i++) {
          var hashclass = '.' + activeHash[i];
          $('.jobkategorieheader'+hashclass, context).css({'display': 'block'});
          $('.jobkategorieheader'+hashclass, context).prev('p').css({'display': 'block'});
          if($(this).next('a').length < 1) {
            $(this).closest('.field-content').append('<a href="/node/6#'+ hash[0] +'" class="close hasjob"><span class="fa fa-check"></span></a>');
            $('.close', context).addClass(hash[0]);
          }
        }
      });

      // Moderne once-Nutzung in Drupal 10
      $(once('vanity-close', '.close', context)).on('click touch', function() {
        var hash = $(this).attr('class').split(' ');
        var hashremove = '.' + hash[2];
        activeHash.splice($.inArray(hash[0], activeHash), 1);
        $('.jobkategorieheader'+hashremove, context).css({'display': 'none'});
        $('.jobkategorieheader'+hashremove, context).prev('p').css({'display': 'none'});
        $(this).remove();
        if(activeHash.length === 0) {
          $('.jobkategorieheader', context).css({'display': 'block'});
          $('.jobkategorieheader', context).prev('p').css({'display': 'block'});
        }
      });

      $('#edit-ich-besitze-kein-telefon-moechte-keine-telefonummer-angeben', context).change(function() {
        if ($(this).is(':checked')) {
          $('.form-item-telefonnummer', context).css({'display':'none'});
          $(this).closest('.form-item').css({'display':'none'});
        }
      });

      $.fn.outerHTML = function() {
        return (this[0]) ? this[0].outerHTML : '';
      };

    }
  }
})(jQuery, Drupal, once);


(function ($, Drupal) {
  $(document).on('dialogopen', '.ui-dialog', function () {
    var $modal = $(this).find('#drupal-modal');
    $(this).blur();
    $modal.scrollTop(0);
  });
})(jQuery, Drupal);
